import { usePathname } from "next/navigation";
import { useIsomorphicLayoutEffect } from "~/lib/hooks/useIsomorphicLayoutEffect";
import { useModal } from "~/lib/hooks/useModal";

export const useFilterModal = () => {
	const path = usePathname().substring(1);
	const { isOpen, openModal, closeModal, toggleModal } = useModal(
		path,
		() => {},
		false,
		false,
		false,
	);

	// Manually open on load due to edge case of mobile
	useIsomorphicLayoutEffect(() => {
		const isLarge = window.matchMedia("(min-width: 1024px)").matches;
		if (isLarge) {
			openModal();
		}
	}, []);

	return {
		isOpen,
		openModal,
		closeModal,
		toggleModal,
	};
};
